import { compose, css, layout, LayoutProps, variant } from '@wrisk/styled-system'
import styled from 'styled-components'

import { Anchor, AnchorProps, mdBumps, smBumps } from '../atoms'
import { withDefaultProps } from '../defaultProps'

export type CollapsibleSectionHeaderProperty = 'default' | 'visible'

export interface CollapsibleSectionHeaderProps extends AnchorProps, LayoutProps {
  variant?: CollapsibleSectionHeaderProperty
}

const defaultProps = withDefaultProps<CollapsibleSectionHeaderProps>({
  variant: 'default',
})

export const CollapsibleSectionHeader = styled(
  Anchor,
).attrs<CollapsibleSectionHeaderProps>(defaultProps)(
  css({
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',

    borderStyle: 'solid',
    borderColor: 'border',
    borderWidth: 0,

    borderTopWidth: 1,
    borderBottomWidth: 1,

    py: mdBumps,
    gap: smBumps,

    wordBreak: 'break-word',

    '& > *:last-child': {
      flexShrink: 0,
    },
  }),
  variant({
    scale: 'CollapsibleSectionHeader',
    variants: {
      default: {},
      active: {},
    },
  }),
  compose(layout),
)
